export const INITIAL_PATIENT_STATUSES = [
  { id: 'Pre-screened', name: 'Pre-screened' },
  { id: 'Pre-screening', name: 'Pre-screening' },
  { id: 'Identified', name: 'Identified' }
];

export const patientStatusMap = [
  { id: 'IDENTIFIED', name: 'Identified' },
  { id: 'PRE-SCREENED', name: 'Pre-screened' },
  { id: 'CONSENTED', name: 'Consented' },
  { id: 'SCREENED', name: 'Screened' },
  { id: 'RUN IN', name: 'Run In' },
  { id: 'RANDOMIZED', name: 'Randomized' },
  { id: 'FOLLOW-UP', name: 'Follow-up' },
  { id: 'COMPLETED', name: 'Completed' },
  { id: 'CANCELED', name: 'Canceled' },
  { id: 'PRE-SCREEN FAILED', name: 'Pre-screen Failed' },
  { id: 'RUN IN FAILED', name: 'Run In Failed' },
  { id: 'WITHDRAWN', name: 'Withdrawn' },
  { id: 'SCREEN FAILED', name: 'Screen Failed' },
  { id: 'TRANSFERRING', name: 'Transferred' },
  { id: 'PRE-SCREENING', name: 'Pre-screening' },
  { id: 'EARLY TERMINATION', name: 'Early Termination' }
];

export function findPatientStatusNameByKey(key) {
  const status = patientStatusMap.find(status => status.id === key);
  return status ? status.name : null;
}

export function getPatientStatusNames() {
  return patientStatusMap.map(status => status.name);
}

export const patientCardStatuses = [
  { id: 'PHYSICAL', name: 'Physical' },
  { id: 'PRE-DIGITAL', name: 'Digital' },
  { id: 'PHYSICAL_NOT_ASSIGNED', name: 'Physical Not Assigned' },
  { id: 'N/A', name: 'N/A' }
];

export const PAYMENT_TYPE_PHYSICAL = 'PHYSICAL';
export const PAYMENT_TYPE_DIGITAL = 'DIGITAL';

export const paymentTypeMap = {
  [PAYMENT_TYPE_PHYSICAL]: 'Physical',
  [PAYMENT_TYPE_DIGITAL]: 'Digital'
};

export const PHYSICAL_NOT_ASSIGNED = 'PHYSICAL_NOT_ASSIGNED';

export const cardAssignmentStatusMap = {
  [PHYSICAL_NOT_ASSIGNED]: 'Physical Not Assigned'
};

export const INITIAL_FILTERS_STATE = {
  statuses: {
    source: [],
    value: []
  },
  ssu: {
    studySites: [],
    studies: [],
    sites: [],
    selectedStudyId: null,
    selectedSiteMap: {},
    selectedStudy: null,
    selectedSites: []
  }
};
